export const bulkFundsFromJSON = (json: IBulkFundsResponse): IBulkFundsModel => ({
	...toCamelCase(json),
})

export const bulkFundsBatchStatusFromJSON = (json: IBulkFundsBatchStatus): IBulkFundsBatchStatusModel => ({
	...toCamelCase(json),
})

export const bulkFundsImportFromJSON = (json: IBulkFundsImportResponse): IBulkFundsImportModel => ({
	...toCamelCase(json),
})

export const WalletLimits = (json: IWalletLimits): IWalletLimitsModel => {
	const { updated_at, ...rest } = json

	return {
		...toCamelCase(rest),
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const WalletLimitsToPayload = (form: IWalletLimitsForm): IWalletLimitsPayload => ({
	...toSnakeCase(form),
})
